const adminRoutes =
	{
		name: 'admin',
		path: '/admin',
		meta: { requiresAuth: true, },
		component: () => import('#modules/admin/AdminModule.vue'),
		children: [
			{
				name: 'admin.suppliers',
				path: 'suppliers',
				component: () => import('#modules/admin/pages/AdminSuppliers.vue')
			},
			{
				name: 'admin.registrations',
				path: 'registrations',
				component: () => import('#modules/admin/pages/AdminRegistrations.vue')
			},
			{
				name: 'admin.manuals',
				path: 'manuals',
				component: () => import('#modules/admin/pages/AdminManuals.vue')
			},
			{
				name: 'admin.sensory',
				path: 'sensory',
				component: () => import('#modules/admin/pages/AdminSensory.vue')
			},
			{
				name: 'admin.modules',
				path: 'modules',
				component: () => import('#modules/admin/pages/AdminModules.vue')
			},
			{
				name: 'admin.features',
				path: 'features',
				component: () => import('#modules/admin/pages/AdminFeatures.vue')
			},
			{
				name: 'admin.systemlanguages',
				path: 'systemlanguages',
				component: () => import('#modules/admin/pages/AdminSystemLanguages.vue')
			},
			{
				name: 'admin.dashboard',
				path: 'dashboard',
				redirect: { name: 'admin.dashboard.index' },
				children: [
					{
						name: 'admin.dashboard.index',
						path: '',
						component: () => import('#modules/admin/pages/DashboardTilesIndex.vue'),
					},
					{
						name: 'admin.dashboard.create',
						path: 'create',
						component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
						props: { isNew: true, isEdit: true }
					},
					{
						name: 'admin.dashboard.show',
						path: ':tileId(\\d+)',
						component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
						props: { isNew: false, isEdit: false }
					},
					{
						name: 'admin.dashboard.edit',
						path: ':tileId(\\d+)/edit',
						component: () => import('#modules/admin/pages/DashboardTilesPage.vue'),
						props: { isNew: false, isEdit: true }
					}
				]
			},
		]
	}

export default adminRoutes
